@if (tripBookingPackage.actual_trip) {
  @if (statusMessage) {
    <div>{{statusMessage}}</div>
  }
  @if (tripBookingPackage.complete_booking_website_url) {
    <div>
      <a target="_blank" [href]="tripBookingPackage.complete_booking_website_url">Link pagina di pagamento</a>
    </div>
  }
  <div class="flex-row items-center justify-start mt-8 flex-gap-16 actions">
    <button mat-raised-button (click)="changeDate()">
      <span class="material-icons-outlined text-color-white">edit</span>
      <span class="text-color-white ml-8">{{'Modifica data' | translate}}</span>
    </button>
    @if (canResendEmail) {
      <button mat-raised-button (click)="resendEmailToCustomer()">
        <span class="material-icons-outlined text-color-white">email</span>
        <span class="text-color-white ml-8">{{'Invia email' | translate}}</span>
      </button>
    }
    @if (canConfirmDate) {
      <button mat-raised-button (click)="confirmDate()">
        <span class="material-icons-outlined text-color-white">done</span>
        <span class="text-color-white ml-8">{{'Conferma date e invia email' | translate}}</span>
      </button>
    }
  </div>
}